import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_ROLE } from './router';

menuRegistry.registerMenu([
    {
        parent: 'SystemWide',
        key: 'Role',
        name: 'Role',
        icon: 'fa fa-users-cog',
        route: { name: ROUTE_NAME_ROLE.SYSTEM.INDEX }
    },

    {
        parent: 'General',
        key: 'Role',
        name: 'Role',
        icon: 'fa fa-users-cog',
        route: { name: ROUTE_NAME_ROLE.APP.INDEX }
    }
]);

export default registerRouteForModule(router);
